module.exports = __webpack_public_path__ + "img/mile3m-m@2.a754c01f.jpg";